module.exports = __webpack_public_path__ + "kit/docs/img/android-chrome-256x256.0ebb373a.png";